<template>
    <div class="wrap" style="margin:0 -12px;">
        <div class="container">
            <div class="row">
                <div class="col px-0">
                    <img src="/images/Group13415.png" class="img-fluid">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-1"></div>
                <div class="col px-0">
                    <div style="padding-right:7.5px;">
                        <img src="/images/Group13417.png" class="img-fluid">
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div>
                            <small> 概要 </small>
                        </div>
                        <p class="error-text" id="error-text_my_like" v-if="this.event_summary.length > this.requiredEventTextMaxLength"><i
                                class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大{{ this.requiredEventTextMaxLength }}文字）
                        </p>
                        <textarea class="luna-form-control" id="event_summary" name="event_summary" rows="5"
                            placeholder="簡単なイベント概要など" v-model="event_summary"></textarea>
                        <div class="text-end" style="font-size:10px;"
                            :class="(this.event_summary.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                            {{ this.event_summary.length }}/{{ this.requiredEventTextMaxLength }}
                        </div>
                        <br />
                        <div>
                            <small> こんな人におすすめ </small>
                        </div>
                        <p class="error-text" id="error-text_my_like" v-if="this.event_recommend.length > this.requiredEventTextMaxLength"><i
                                class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大{{ this.requiredEventTextMaxLength }}文字）
                        </p>
                        <textarea class="luna-form-control" id="event_recommend" name="event_recommend" rows="5"
                            placeholder="是非とも参加してほしい方のイメージなど" v-model="event_recommend"></textarea>
                        <div class="text-end" style="font-size:10px;"
                            :class="(this.event_recommend.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                            {{ this.event_recommend.length }}/{{ this.requiredEventTextMaxLength }}
                        </div>
                        <br />
                        <div>
                            <small> イベント詳細 </small>
                        </div>
                        <p class="error-text" id="error-text_my_like" v-if="this.event_details.length > this.requiredEventTextMaxLength"><i
                                class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大{{ this.requiredEventTextMaxLength }}文字）
                        </p>
                        <textarea class="luna-form-control" id="event_details" name="event_details" rows="5"
                            placeholder="どんなイベントか・タイムスケジュールなど" v-model="event_details"></textarea>
                        <div class="text-end" style="font-size:10px;"
                            :class="(this.event_details.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                            {{ this.event_details.length }}/{{ this.requiredEventTextMaxLength }}
                        </div>
                        <br />
                        <div>
                            <small> 注意事項 </small>
                        </div>
                        <p class="error-text" id="error-text_my_like" v-if="this.event_notes.length > this.requiredEventTextMaxLength"><i
                                class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大{{ this.requiredEventTextMaxLength }}文字）
                        </p>
                        <textarea class="luna-form-control" id="event_notes" name="event_notes" rows="5"
                            placeholder="注意事項・　禁止事項・ルールなど" v-model="event_notes"></textarea>
                        <div class="text-end" style="font-size:10px;"
                            :class="(this.event_notes.length > this.requiredEventTextMaxLength) ? 'err_color' : 'color:#999'">
                            {{ this.event_notes.length }}/{{ this.requiredEventTextMaxLength }}
                        </div>
                        <br />
                        <div>
                            <small> 決済方法・費用 </small>
                        </div>
                        <div class="row" style="padding:0 12px;">
                            <div class="col-6 px-0">
                                <div style="padding-right:3px;padding-bottom:6px;">
                                    <div class="luna-search-select-bar">
                                        <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                            <input class="form-check-input-luna" type="checkbox" disabled
                                                v-model="is_amount1"
                                                style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                            <label class="form-check-label" style="font-size:10px;font-weight: bold;">
                                                当日決済
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 px-0">
                                <div style="padding-left:3px;padding-bottom:6px;">
                                    <div class="luna-search-bar">
                                        <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                            <input class="form-check-input-luna" type="checkbox" disabled
                                                v-model="is_amount2"
                                                style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                            <label class="form-check-label" style="font-size:10px;">
                                                事前決済（後日実装）
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 1">
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    1部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    男性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount1" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    女性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount2" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 1">
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    2部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    男性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount3" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    女性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount4" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 2">
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    3部
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    男性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount5" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    女性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount6" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                        </div>
                        <div v-show="event_type_val > 0">
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                    通し
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    男性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount7" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                            <div class="row" style="padding-top:10px">
                                <div class="col-2 text-end" style="padding-top:15px;">
                                </div>
                                <div class="col-2 text-center" style="padding-top:15px;">
                                    女性
                                </div>
                                <div class="col">
                                    <input type="text" class="luna-form-control" v-model="amount8" />
                                </div>
                                <div class="col-2" style="padding-top:15px;">
                                    円
                                </div>
                            </div>
                        </div>
                        <br />
                        <div>
                            <small> チケットの設定 </small>
                        </div>
                        <div class="row" style="padding:0 12px;">
                            <div class="col-6 px-0">
                                <div style="padding-right:3px;padding-bottom:6px;">
                                    <div class="luna-search-select-bar">
                                        <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                            <input class="form-check-input-luna" type="checkbox" disabled
                                                v-model="is_amount1"
                                                style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                            <label class="form-check-label" style="font-size:10px;font-weight: bold;">
                                                先着制
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 px-0">
                                <div style="padding-left:3px;padding-bottom:6px;">
                                    <div class="luna-search-bar">
                                        <div class="form-check" style="padding-left:0;margin-bottom:2px;">
                                            <input class="form-check-input-luna" type="checkbox" disabled
                                                v-model="is_amount2"
                                                style="width:16px;height:16px;float:none;margin-left:0;margin-top:6px;">
                                            <label class="form-check-label" style="font-size:10px;">
                                                抽選制（後日実装）
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row justify-content-center">
                <div class="col-9">
                    <br />
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna disabled" style="padding: 12px 0" v-if="is_load">
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna" style="padding: 12px 0" @click="setEvent()" id="on-btn"
                            v-else-if="isEventNext()">
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0" id="non-btn" v-else>
                            次へ
                        </button>
                    </div>
                    <p class="error-text text-center" id="error-text_my_like" v-if="!isEventNext()">
                        <i class="bi bi-x-circle-fill"></i>未入力の項目があります。
                    </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <a href="/event/entry/question1" style="font-size:12px;">
                        <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                            <use xlink:href="/images/<.svg#page_left"></use>
                        </svg>&nbsp;前のフォームに戻る</a>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
import { hasValidRequiredEventTexts, isBlank, normalizeRequiredEventTextFields, REQUIRED_EVENT_TEXT_MAX_LENGTH } from "../../../helpers/eventText";

export default {
    data() {
        return {
            is_amount1: true,
            is_amount2: false,

            is_load: false,

            amount1: "",
            amount2: "",
            amount3: "",
            amount4: "",
            amount5: "",
            amount6: "",
            amount7: "",
            amount8: "",

            event_summary: "",
            event_recommend: "",
            event_details: "",

            event_notes: "",

            player_type: 0,
            event_type_val: 0,
            event_info: {},
            requiredEventTextMaxLength: REQUIRED_EVENT_TEXT_MAX_LENGTH,
        };
    },
    methods: {
        isEventNext() {
            const eventTexts = normalizeRequiredEventTextFields({
                event_details: this.event_details,
                event_recommend: this.event_recommend,
                event_summary: this.event_summary,
                event_notes: this.event_notes,
            })

            if (!hasValidRequiredEventTexts(eventTexts)) {
                return false
            }

            if (this.event_type_val == 1) {
                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }
            else if (this.event_type_val == 2) {

                if (isBlank(this.amount1)) {
                    return false
                }
                if (isBlank(this.amount2)) {
                    return false
                }

                if (isBlank(this.amount3)) {
                    return false
                }
                if (isBlank(this.amount4)) {
                    return false
                }

                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }
            else if (this.event_type_val == 3) {

                if (isBlank(this.amount1)) {
                    return false
                }
                if (isBlank(this.amount2)) {
                    return false
                }

                if (isBlank(this.amount3)) {
                    return false
                }
                if (isBlank(this.amount4)) {
                    return false
                }

                if (isBlank(this.amount5)) {
                    return false
                }
                if (isBlank(this.amount6)) {
                    return false
                }

                if (isBlank(this.amount7)) {
                    return false
                }
                if (isBlank(this.amount8)) {
                    return false
                }
            }

            return true
        },
        addPlayerInput() {
            let player = { value: "" }
            this.players.push(player)
        },
        rmPlayerInput(index) {
            this.players.splice(index, 1)
        },
        initEvent() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                let serializedArray = localStorage.getItem('luna_event_entry');
                let event = JSON.parse(serializedArray);

                this.event_info = event

                this.event_type_val = event['event_type_val']
                this.player_type = event['player_type']

                this.event_details = (event['event_details'] == undefined) ? "" : event['event_details']
                this.event_summary = (event['event_summary'] == undefined) ? "" : event['event_summary']
                this.event_recommend = (event['event_recommend'] == undefined) ? "" : event['event_recommend']
                this.event_notes = (event['event_notes'] == undefined) ? "" : event['event_notes']
                this.amount1 = (event['amount1'] == undefined) ? "" : event['amount1']
                this.amount2 = (event['amount2'] == undefined) ? "" : event['amount2']
                this.amount3 = (event['amount3'] == undefined) ? "" : event['amount3']
                this.amount4 = (event['amount4'] == undefined) ? "" : event['amount4']
                this.amount5 = (event['amount5'] == undefined) ? "" : event['amount5']
                this.amount6 = (event['amount6'] == undefined) ? "" : event['amount6']
                this.amount7 = (event['amount7'] == undefined) ? "" : event['amount7']
                this.amount8 = (event['amount8'] == undefined) ? "" : event['amount8']
            }
        },
        rmEventInfo() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                localStorage.removeItem('luna_event_entry')
            }
        },
        setEvent() {
            if (!this.isEventNext()) {
                this.$showErrorToast("入力内容を確認してください")
                return
            }

            const eventTexts = normalizeRequiredEventTextFields({
                event_details: this.event_details,
                event_recommend: this.event_recommend,
                event_summary: this.event_summary,
                event_notes: this.event_notes,
            })

            let event = {
                'thumbnail': this.event_info['thumbnail'],
                'event_at': this.event_info['event_at'],
                'event_at_open_1': this.event_info['event_at_open_1'],
                'event_at_from_1': this.event_info['event_at_from_1'],
                'event_at_to_1': this.event_info['event_at_to_1'],
                'event_at_open_2': this.event_info['event_at_open_2'],
                'event_at_from_2': this.event_info['event_at_from_2'],
                'event_at_to_2': this.event_info['event_at_to_2'],
                'event_at_open_3': this.event_info['event_at_open_3'],
                'event_at_from_3': this.event_info['event_at_from_3'],
                'event_at_to_3': this.event_info['event_at_to_3'],
                'event_type': this.event_info['event_type'],
                'event_type_val': this.event_info['event_type_val'],

                ...eventTexts,

                'img_url': this.event_info['img_url'],

                'amount1': this.amount1,
                'amount2': this.amount2,
                'amount3': this.amount3,
                'amount4': this.amount4,
                'amount5': this.amount5,
                'amount6': this.amount6,
                'amount7': this.amount7,
                'amount8': this.amount8,

                'address': this.event_info['address'],
                'area': this.event_info['area'],
                'area_value': this.event_info['area_value'],

                'is_player': this.event_info['is_player'],
                'players': this.event_info['players'],
                'player_type': this.event_info['player_type'],

                'member_count': this.event_info['member_count'],
                'organizer': this.event_info['organizer'],
                'venue_name': this.event_info['venue_name'],

                'customer_mail': (this.event_info['customer_mail'] == undefined) ? '' : this.event_info['customer_mail'],
            }
            const serializedArray = JSON.stringify(event)
            localStorage.setItem('luna_event_entry', serializedArray)

            window.location.href = "/event/entry/question3"
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.initEvent()
                            this.isAuth()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.initEvent()
                this.isAuth()
            }
        }
        else {
            this.initEvent()
            this.isAuth()
        }
    },
};
</script>

<style scoped>
small {
    color: #5538EE;
}

.err_color {
    color: red;
}

.select_sex {
    border: 0px;
}

.vs__dropdown-toggle {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
}

.vs__selected-options {
    color: #cdcfd0;
}

.sub_windows {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}

.luna-search-bar {
    padding: 8px 12px 10px 12px;
    background-color: #fff;
    border-radius: 5px;
    color: #333333;
    border: 1px solid #E6E6E6;
}


.luna-search-select-bar {
    padding: 8px 12px 10px 12px;
    background-color: #f0f0ff;
    border-radius: 5px;
    color: #000000;
}
</style>
